import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useOrchestrationStore = defineStore("orchestration", {
    actions: {
        async orchestrationListFetch(payload) {
            const body = {
                page: {
                    index: payload.index,
                    size: payload.size,
                    sort: "",
                },
                filter: {
                    shopUid: payload.shopUid,
                    cusUid: payload.cusUid,
                    cusName: payload.cusName,
                    txState: payload.txState,//INITIALIZED, WAITING_FOR_PAYMENT, PAYMENT_RECEIVED, IN_PROGRESS, COMPLETED, INCOMPLETE, CANCELLED
                    transferStatus: payload.transferStatus,//INITIAL, IN_PROCESS, COMPLETE, FAILURE, CANCEL
                    refNumber: payload.refNumber,
                    paymentGroupUid: payload.paymentGroupUid,
                    fromDate: payload.fromDate,
                    toDate: payload.toDate

                },
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/orch-svc/pawn/shop/tx/list";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async orchestrationInfoFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/orch-svc/pawn/shop/tx/" + payload.uid;
                    const response = http.get(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async manualCompletedFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/orch-svc/pawn/shop/tx/completed/" + payload.uid;
                    const response = http.post(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },


        async orchestrationAdminListFetch(payload) {
            const body = {
                page: {
                    index: payload.index,
                    size: payload.size,
                    sort: "",
                },
                filter: {
                    shopUid: payload.shopUid,
                    cusUid: payload.cusUid,
                    cusName: payload.cusName,
                    paymentGroupUid: payload.paymentGroupUid,
                    fromDate: payload.fromDate,
                    toDate: payload.toDate
                },
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/orch-svc/pawn/cus/tx/list";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async manualCompletedAdminFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/orch-svc/pawn/cus/tx/completed/" + payload.shopUid + "/" + payload.uid;
                    const response = http.post(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async deleteTxFetch(payload) {
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl =
                        "/orch-svc/pawn/cus/tx/delete/" +
                        payload.shopUid +
                        "/" +
                        payload.uid;
                    const response = http.delete(pathUrl);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

    }
});